import React, { Component } from "react";
//UI
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";

//library
import { connect } from "react-redux";
import { Form, Field, Formik } from "formik";
import { Auth } from "aws-amplify";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";
//component
import { setGlobalParam } from "../../reducers/reducers";
import {
  TextFieldComponent,
  SelectComponent,
} from "../../components/FormComponent";
import EmailData from "../../Controls/Select/DataCompanyEmail";
import EmailDataPETCO from "../../Controls/Select/DataCompanyEmailPETCO";
import EmailDataPETCOSurveyor from "../../Controls/Select/DataCompanyEmailPETCOSurveyor";
import EmailDataPDBAgentCompany from "../../Controls/Select/DataPDBAgentCompany";
import _verifyEmailLogin from "./_verifyEmail.login";
import DataAccessCategory from "../../Controls/Select/DataAccessCategory.json";
import { GROUP_OPU, REGISTER_ERROR_CODE } from "../../config/constant";

const RegisterSchema = Yup.object().shape({
  full_name: Yup.string().required("Name is required"),
  password: Yup.string().required("Password is required"),
  repeat_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Password confirm is required"),
  email: Yup.string()
    .email()
    .required("Required"),
  // agree: Yup.boolean().oneOf([true], 'Field must be checked'),
});
class Register extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: setGlobalParam,
      storage: "login.show_register_component",
      response: true,
    });
  }

  useRegister = async (values, setFieldError, resetForm) => {
    const { dispatch } = this.props;
    try {
      let isEmailExist = false;
      let isUserExist = false;

      let userType = values.access_category.split(",");
      let is_all_user_exist = [];

      let email_list = values.company_email.split(",");
      let is_all_email_exist = [];

      userType.map((values, index) => {
        DataAccessCategory.map((item, index) => {
          if (item.value == values && item.value != "") {
            is_all_user_exist.push(true);
          }
        });
      });

      if (userType.length == is_all_user_exist.length) {
        isUserExist = true;
      }

      if (isUserExist) {
        if (userType == "admin") {
          email_list.map((values, index) => {
            EmailData.map((item, index) => {
              if (item.value == values && item.value != "") {
                is_all_email_exist.push(true);
              }
            });
          });

          if (email_list.length == is_all_email_exist.length) {
            isEmailExist = true;
          }
        } else if (userType == "hq") {
          email_list.map((values, index) => {
            EmailDataPDBAgentCompany.map((item, index) => {
              if (item.value == values && item.value != "") {
                is_all_email_exist.push(true);
              }
            });
          });

          if (email_list.length == is_all_email_exist.length) {
            isEmailExist = true;
          }
        } else if (userType == "petco_admin") {
          email_list.map((values, index) => {
            EmailDataPETCO.map((item, index) => {
              if (item.value == values && item.value != "") {
                is_all_email_exist.push(true);
              }
            });
          });

          if (email_list.length == is_all_email_exist.length) {
            isEmailExist = true;
          }
        } else if (userType == "pli_admin") {
          email_list.map((values, index) => {
            EmailDataPETCO.map((item, index) => {
              if (item.value == values && item.value != "") {
                is_all_email_exist.push(true);
              }
            });
          });

          if (email_list.length == is_all_email_exist.length) {
            isEmailExist = true;
          }
        } else if (userType == "pcg_admin") {
          email_list.map((values, index) => {
            EmailDataPETCO.map((item, index) => {
              if (item.value == values && item.value != "") {
                is_all_email_exist.push(true);
              }
            });
          });

          if (email_list.length == is_all_email_exist.length) {
            isEmailExist = true;
          }
        } else if (userType == "petco_surveyor") {
          email_list.map((values, index) => {
            EmailDataPETCOSurveyor.map((item, index) => {
              if (item.value == values && item.value != "") {
                is_all_email_exist.push(true);
              }
            });
          });

          if (email_list.length == is_all_email_exist.length) {
            isEmailExist = true;
          }
        } else {
          email_list.map((values, index) => {
            EmailData.map((item, index) => {
              if (item.value == values && item.value != "") {
                is_all_email_exist.push(true);
              }
            });
          });

          if (email_list.length == is_all_email_exist.length) {
            isEmailExist = true;
          }
        }
      }

      if (isEmailExist) {
        const code = await Auth.signUp({
          username: values.email,
          password: values.password,
          company_name: values.company_name,
          opu: GROUP_OPU[userType],
          attributes: {
            preferred_username: values.email,
            email: values.email,
            name: values.full_name,
            "custom:company_email": values.company_email,
            "custom:date_created": moment().format("YYYY-MM-DD HH:mm:ss"),
            "custom:is_approve": "0",
            "custom:opu": values.access_category,
            "custom:is_enable": "0",
          },
        });

        dispatch({
          type: setGlobalParam,
          storage: "login.register_form",
          response: values,
        });

        dispatch({
          type: setGlobalParam,
          storage: "login.show_register_component",
          response: true,
        });

        resetForm({
          //username will be user email
          username: "",
          user_name: "",
          password: "",
          repeat_password: "",
          //email will also be user email
          email: "",
          company_email: "",
          date_created: "",
          agree: false,
        });

        toast.success(
          "User successfully created. Your verification code has been sent to your individual email address"
        );

        dispatch({
          type: setGlobalParam,
          storage: "login.show_verifyemail_component",
          response: true,
        });

        dispatch({
          type: setGlobalParam,
          storage: "login.show_successVerified_component",
          response: false,
        });
      } else {
        setFieldError("company_email", "Company Email does not exist");
      }
    } catch (error) {
      console.log("error.message", error);
      switch (error.code) {
        case REGISTER_ERROR_CODE.ACCOUNT_EXIST:
          toast.error("Account already exists");
          break;
        case REGISTER_ERROR_CODE.INVALID_PASSWORD:
          toast.error(
            "Password does not meet requirement. (Minimum 8 char,1 number,1 lower case, 1 upper case, 1 symbol)"
          );
          break;
        default:
          toast.error("Network error");
          break;
      }
    }
  };
  render() {
    const {
      register_form,
      is_register_loading,
      show_verifyemail_component,
    } = this.props;

    if (show_verifyemail_component) {
      return <_verifyEmailLogin />;
    }

    return (
      <div className="register-form">
        <Typography
          component="h3"
          variant="h3"
          className="text-center"
        >
          VOPS
        </Typography>
        <br />
        <Typography component="h1" variant="h5" className="text-center">
          Request Account
        </Typography>

        <br />

        <Formik
          initialValues={register_form}
          validationSchema={RegisterSchema}
          enableReinitialize={true}
          onSubmit={(values, { setSubmitting, resetForm, setFieldError }) => {
            this.useRegister(values, setFieldError, resetForm);
          }}
          render={({ values, resetForm, handleSubmit, errors }) => (
            <Form onSubmit={handleSubmit}>
              <Grid container spacing={24}>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="company_name"
                    label="Company Name"
                    component={TextFieldComponent}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="company_email"
                    label="Company Group Email Address"
                    component={TextFieldComponent}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="full_name"
                    type="text"
                    label="Full Name"
                    component={TextFieldComponent}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="email"
                    type="text"
                    label="Individual Email Address"
                    component={TextFieldComponent}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="password"
                    type="password"
                    label="Password (Minimum 8 char,1 number,1 lower case, 1 upper case, 1 symbol)"
                    component={TextFieldComponent}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="repeat_password"
                    type="password"
                    label="Confirm Password"
                    component={TextFieldComponent}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    name="access_category"
                    type="text"
                    label="Access Category"
                    data={DataAccessCategory}
                    component={SelectComponent}
                  />
                </Grid>
              </Grid>

              <span>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  type="submit"
                  disabled={is_register_loading}
                >
                  Create Account
                </Button>
                {is_register_loading ? (
                  <CircularProgress size={24} className="progress" />
                ) : (
                    ""
                  )}
              </span>
              <br />
            </Form>
          )}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({ ...state.reducer.login }),
  (dispatch) => ({ dispatch })
)(Register);



// WEBPACK FOOTER //
// ./src/containers/Login/_register.login.js